/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectRentalPlan from 'modules/me/select-rental-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import { hasScheduledChanges } from 'state/current-retailer-rental/selectors';
import CurrentRetailerRentalPlanCard from '../index/current-rental-plan-card';
import { isMultiStore } from 'state/current-user/selectors'

// new
import Button from 'components/button';
import ScheduledChangesNotice from 'modules/me/rental/scheduled-changes-notice';
import MultiStoreNotice from 'modules/me/rental/multi-store-notice';

const EditRental = (props) => {
    return (
        <Box>
            <DocumentHead title='Manage Billing - Tower Systems' />
            <Topbar title='Rental Plan' subTitle='Manage your Rental subscription' selected='rental'>
                <Button primary link='/dashboard/rental'>
                    View Subscription Details
                </Button>
            </Topbar>
            {props.isMultiStore && (
                <Box >
                    <MultiStoreNotice></MultiStoreNotice>
                </Box>
            )}
            {props.hasScheduledChanges && (
                <Box marginBottom='xxlarge'>
                    <ScheduledChangesNotice></ScheduledChangesNotice>
                </Box>
            )}
    
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Rental plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a Rental plan below to view
                            the estimated plan price.
                        </Text>
                    </Box>
                    <Box> 
                        <SelectRentalPlan />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        isMultiStore: isMultiStore(state),
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {hasScheduledChanges},
)(EditRental);
